import React, { useEffect, useState } from "react";
import axios from "../../../axios";
import { StudentPersonalDetailsType } from "../types";
import TheSpinner from "../../TheSpinner";
import { Table, TableColumnProps, Tag, Tooltip } from "antd";
import { dateDisplayable } from "../../table-utils";
import { STUDENT_DEALINGS_STATUS_COLORS, TABLE_LIMIT } from "../../constants";
import TutorCommentsPopup from "../TutorCommentsPopup";

interface HistoryProps {
  studentDetails: StudentPersonalDetailsType;
}

type HistoryRecordType = {
  shortlist_id: number;
  dealings_id: number;
  created_at: string;
  tutorID: number;
  tutor_name: string;
  gender: string;
  confirmed_tuition_date: string;
  start_date: string;
  status: string;
  fee_discuss: null;
  subject: string;
  comment_count: number;
};

const History: React.FC<HistoryProps> = (props: HistoryProps) => {
  const { studentDetails } = props;
  const [history, setHistory] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [enquiry, setEnquiry] = useState(0);
  const [confirmation, setConfirmation] = useState(0);

  const _columns: TableColumnProps<HistoryRecordType>[] = [
    {
      title: "Enquiry Date",
      dataIndex: "created_at",
      key: "created_at",
      width: 100,
      render: dateDisplayable,
    },
    {
      title: "Deal ID",
      dataIndex: "dealings_id",
      key: "dealings_id",
      width: 70,
    },
    {
      title: "Tutor Name",
      dataIndex: "tutor_name",
      key: "tutor_name",
      width: 200,
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      width: 60,
    },
    {
      title: "Confirmation Date",
      dataIndex: "confirmed_tuition_date",
      key: "confirmed_tuition_date",
      width: 100,
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      key: "start_date",
      width: 100,
    },
    {
      title: "Subjects",
      dataIndex: "subject",
      key: "subject",
      width: 200,
      ellipsis: true,
      render: (_: any, record) => {
        return (
          <Tooltip placement="topLeft" title={record.subject}>
            <div
              style={{
                padding: "5px",
              }}
            >
              {record.subject}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "dealing_status",
      key: "dealing_status",
      width: 100,
			render: (_: any, { status }: { status: string }) => (
				<Tag color={STUDENT_DEALINGS_STATUS_COLORS[status as keyof typeof  STUDENT_DEALINGS_STATUS_COLORS]}>{status}</Tag>
      ),
    },
    {
      title: "Pre Finalised Fees",
      dataIndex: "fee_discuss",
      key: "fee_discuss",
      width: 100,
    },
		{
      title: "Fee percent",
      dataIndex: "fee_percent",
      key: "fee_percent",
      width: 100,
    },
    {
      title: "Comments",
      dataIndex: "comments",
      key: "comments",
      width: 200,
      align: "center",
      render: (cellValue: string, record) => (
        <TutorCommentsPopup cellValue={cellValue} data={{ shortlist_id: record.shortlist_id, comment_count: record.comment_count || 0 }} />
      ),
    },
  ];

  useEffect(() => {
    fetchHistory();
  }, []);

  async function fetchHistory() {
    try {
      const { data } = await axios.get(
        `/v1/cre/student/deal/all/tutor-history`,
        {
          params: {
            student_id: studentDetails.userId,
          },
        }
      );
      console.log("The api response data is ", data);

      // setHistory(response.data);
      setHistory(data.data.result);
      setEnquiry(data.data.total_enquiry);
      setConfirmation(data.data.total_confirmation);
    } catch (err) {
      console.log("Error is ", err);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return <TheSpinner />;
  }

  return (
    <div className="tail-mt-4">
      <div className="tail-flex tail-justify-between">
        <h2 className="tail-text-lg tail-font-medium">
          Previous Tutor History
        </h2>
        <h3 className="tail-flex tail-gap-x-8 tail-text-base tail-font-medium">
          <span className="tail-text-blue-500">Total Enquiry : {enquiry}</span>
          <span className="tail-text-green-500">
            Total Confirmation : {confirmation}
          </span>
        </h3>
      </div>
      <Table
        dataSource={history}
        bordered
        pagination={{ pageSize: TABLE_LIMIT }}
        scroll={{ x: "100%" }}
        tableLayout="fixed"
        columns={_columns}
      />
    </div>
  );
};

export default History;
